module.exports = __webpack_public_path__ + "img/rotostop_logo.709a6044.png";